import { render, staticRenderFns } from "./TheWalletValuesSummary.vue?vue&type=template&id=34a4b0be&"
import script from "./TheWalletValuesSummary.vue?vue&type=script&lang=js&"
export * from "./TheWalletValuesSummary.vue?vue&type=script&lang=js&"
import style0 from "./TheWalletValuesSummary.vue?vue&type=style&index=0&id=34a4b0be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports